import React from 'react';
import { Wrapper } from './styles';

const LoginLayout: React.FC = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default LoginLayout;
